exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-backdrop[data-v-5e8a641f] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 9;\n}\n.menu-header[data-v-5e8a641f] {\n  margin: 0.25rem 0 0.5rem;\n}\n.menu-nav-item a[data-v-5e8a641f] {\n  display: block;\n}\n.menu-content[data-v-5e8a641f] {\n  padding: 2rem 1rem 0.5rem;\n  width: 10rem;\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-radius: var(--radius);\n  background-color: var(--inverted);\n  box-shadow: 0 1.25rem 3.25rem var(--shadow), 0 0.75rem 1.25rem var(--shadow);\n  z-index: 19;\n}", ""]);

// exports
